<template>
  <main class="flex-fill">
    <app-nav v-if="$store.getters.isAuth" :items="nav"></app-nav>
      <b-row class="noMargin">
        <b-col cols="2" class="noMargin noPadding sidebar shadow-lg" v-if="$store.getters.isAuth && !isMobile()">
          <sidebar-nav class="pt-2" :items="nav"></sidebar-nav>
        </b-col>
        <b-col :cols="$store.getters.isAuth && !isMobile() ? '10':'12'" class="p-0">
          <router-view :class=" $store.getters.isAuth ? 'p-4 main-content' : 'main-content'"/>
        </b-col>
      </b-row>
  </main>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        nav: { 
            admin: [
                    {
                        title: 'sidebar.events',
                        href: "/events",
                        icon: "far fa-calendar-alt",
                        admin: true
                    },
                    {
                        title: 'sidebar.sales',
                        href: "/sales/events",
                        icon: "fas fa-hand-holding-usd",
                        admin: true
                    },
                    {
                        title: 'sidebar.eventLogs',
                        href: "/eventLogs",
                        icon: "fas fa-th-list",
                        admin: true, 
                        guest: true
                    },
                    {
                        title: 'sidebar.dashboard',
                        href: "/dashboard",
                        icon: "fas fa-chart-line",
                        show: true,
                        admin: true
                    },
                    {
                        title: 'sidebar.users',
                        href: "/users",
                        icon: "fas fa-user",
                        show: true,
                        admin: true
                    },
                    {
                        title: 'sidebar.prepaid',
                        href: "/prepaid",
                        icon: "fas fa-credit-card",
                        show: true,
                        admin: true
                    },
                    {
                        title: 'sidebar.sectors',
                        href: "/sectors",
                        icon: "fab fa-buromobelexperte",
                        show: true,
                        admin: true
                    },
                    {
                        title: 'sidebar.ticketCheck',
                        href: "/ticket_scan",
                        icon: "fas fa-barcode",
                        admin: true,
                        sales: true,
                        guest: true
                    },
                    {
                        title: 'sidebar.printJobs',
                        href: "/print_jobs",
                        icon: "fa fa-print",
                        admin: true
                    },
                ],
              sales: [
                {
                        title: 'sidebar.sales',
                        href: "/salesman",
                        icon: "fas fa-hand-holding-usd",
                        sales: true
                    },
                    {
                        title: 'sidebar.ticketCheck',
                        href: "/ticket_scan",
                        icon: "fas fa-barcode",
                        sales: true
                    },
                ],
                guest: [
                  {
                        title: 'sidebar.eventLogs',
                        href: "/eventLogs",
                        icon: "fas fa-th-list",
                        guest: true
                    },
                    {
                        title: 'sidebar.ticketCheck',
                        href: "/ticket_scan",
                        icon: "fas fa-barcode",
                        guest:true
                    },
                ],
                },
        hr: {
          days: ['Ned', 'Pon', 'Uto', 'Sri', 'Čet', 'Pet', 'Sub'],
          months: ['Siječanj', 'Veljača', 'Ožujak', 'Travanj', 'Svibanj', 'Lipanj', 'Srpanj', 'Kolovoz',
            'Rujan', 'Listopad', 'Studeni', 'Prosinac'],
          pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
          placeholder: {
            date: 'Odaberi datum',
            dateRange: 'Odaberi raspon'
          }
        },
        en: {
          days: ['Sun', 'Mon', 'Tue', 'Wend', 'Thu', 'Fri', 'Sat'],
          months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
            'September', 'October', 'November', 'December'],
          pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
          placeholder: {
            date: 'Select a date',
            dateRange: 'Select a date range'
          }
        },
      }
    },
    computed: {
      isAuth () {
        return this.$store.getters.isAuth;
      },
       ...mapGetters({ currentUser: 'currentUser' })
    },
    methods: {
      isMobile(){
        let width  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if(width <1200 ) {
          return true;
        }
        else return false;
      }
    },
    mounted(){
    },
    created() {
      this.$store.dispatch('authenticate');
      this.isMobile();
      
    },
  }
</script>

<style lang="scss">
  @import "assets/sass/app.scss";

  @media screen and (max-width: 1024px) {
    .sidebar {
      visibility: hidden;
      clear: both;
      float: left;
      margin: 10px auto 5px 20px;
      width: 28%;
      display: none;
      
    }
  }
  .main-content{
    background-image: url('./assets/img/club-logo2.png');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 70vh;
  }
</style>